import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/member/${VERSION}/dictionary`;
export default {
  /***
   * 根据编码获取字典数据集合
   */
  list(data,params) {
    return axios({
      url: `${_MODULE}/list`,
      method: `POST`,
      data,
      params
    })
  }
}


// WEBPACK FOOTER //
// ./src/apis/src/dictionary.js